import { render, staticRenderFns } from "./CheckoutOrderSummary.vue?vue&type=template&id=2d994f6c&"
import script from "./CheckoutOrderSummary.vue?vue&type=script&lang=ts&"
export * from "./CheckoutOrderSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d994f6c')) {
      api.createRecord('2d994f6c', component.options)
    } else {
      api.reload('2d994f6c', component.options)
    }
    module.hot.accept("./CheckoutOrderSummary.vue?vue&type=template&id=2d994f6c&", function () {
      api.rerender('2d994f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/checkout/CheckoutOrderSummary.vue"
export default component.exports